import React from "react";
import { ICardPlaceholderProps } from "@model/UIComponents.model";
import styles from "./UiLibraryComponent.module.css";

const CardPlaceholder: React.FC<ICardPlaceholderProps> = ({
  count = 10,
  customWrapperStyle = "",
}) => {
  return (
    <div
      className={`${styles.placeholderWrapper} ${customWrapperStyle}`}
      data-testid="card-placeholder-wrapper"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={styles.cardPlaceholder}
          data-testid={`card-placeholder-${index}`}
        >
          <div className={styles.placeholderImage} />
          <div className={styles.placeholderBody}>
            <div className={`${styles.placeholderLine} ${styles.titleLine}`} />
            <div className={`${styles.placeholderLine} ${styles.textLine}`} />
            <div className={`${styles.placeholderLine} ${styles.textLine}`} />
          </div>

          <div className={styles.placeholderFooter}>
            <div className={`${styles.placeholderPill}`} />
            <div className={`${styles.placeholderButton}`} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardPlaceholder;
